import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  defaultHangarBasicInfo,
  defaultHangarOtherFacilities,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const propertyOwnerHangarSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    ...defaultHangarBasicInfo,
    price: usePurchasePriceOnRequestCondition,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  otherFacilities: defaultHangarOtherFacilities,
  connections: defaultConnections,
}
